import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import { resolveImg } from "@/lib/api";

export default function Blog() {
  const { blog } = useData();
  const [cat, setCat] = useState("Tutte");
  const categories = useMemo(() => ["Tutte", ...Array.from(new Set(blog.map((b) => b.categoria)))], [blog]);
  const list = cat === "Tutte" ? blog : blog.filter((b) => b.categoria === cat);

  return (
    <>
      <Seo title="Blog" description="Consigli e approfondimenti sulla cura del giardino, potature, piante e manutenzione stagionale del verde." path="/blog" />
      <PageHero
        overline="Consigli per il verde"
        title="Blog"
        subtitle="Approfondimenti e consigli generali sulla cura del verde. Alcuni articoli sono ancora in bozza."
        breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Blog</span></>}
      />
      <section className="bg-av-black py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="flex flex-wrap gap-2.5 mb-12">
            {categories.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
                      className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${cat === c ? "bg-av-bright text-av-black" : "border border-white/20 text-av-white/80 hover:border-av-lime hover:text-av-lime"}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {list.map((b, i) => (
              <Reveal key={b.id} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="group block">
                  <div className="relative overflow-hidden rounded-2xl aspect-[16/10]">
                    <img src={resolveImg(b.immagine)} alt={b.titolo} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    {b.placeholder && <span className="absolute top-3 right-3 rounded-full bg-av-bright/90 px-2.5 py-1 text-[10px] font-semibold uppercase text-av-black">Bozza</span>}
                  </div>
                  <p className="mt-4 overline text-av-bright">{b.categoria}</p>
                  <h2 className="mt-2 font-display text-xl text-av-white group-hover:text-av-lime transition-colors">{b.titolo}</h2>
                  <p className="mt-2 text-sm text-av-gray line-clamp-2">{b.estratto}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-av-lime opacity-90">Leggi <ArrowUpRight size={14} /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
